export enum TaskPriorities {
  No_Priority = 0,
  One_Star = 1,
  Two_Star = 2,
  Three_Star = 3,
}
